export default __webpack_public_path__ + "static/media/JB2021Catalogue-400x482.a685afe7.jpg";